import {
  OnDemandVideoEntity,
  MarkdownTextDto,
} from "@citychallenge/api-public";

export class OnDemandVideoModel
  implements
    Omit<
      OnDemandVideoEntity,
      "company" | "groups" | "videoAnalytics" | "baseLanguage" | "translations"
    >
{
  public static readonly THUMBNAIL_WIDTH = 480;
  public id!: string;
  public name!: string;
  public video?: string;
  public image?: string;
  public text?: MarkdownTextDto;
  public weight?: number;
  public attachment?: string;
  public created?: string;
  public updated?: string;

  constructor(data: OnDemandVideoEntity) {
    Object.assign(this, data);
  }
}
